import React from 'react';
import { Button, Tag, useMediaQueryContext } from '@fourthwall/components';
import { DomainString } from '../DomainString/DomainString';
import * as S from './CurrentDomain.styled';
export const CurrentDomain = ({ domain, tag, claimLabel = 'Claim', isClaiming, onClaim, }) => {
    const media = useMediaQueryContext();
    return (React.createElement(S.Container, null,
        React.createElement(S.Content, null,
            React.createElement(S.DomainName, null,
                React.createElement(DomainString, { domain: domain })),
            tag && React.createElement(Tag, { ...tag })),
        onClaim && (React.createElement(Button, { appearance: "primary", size: "small", fullWidth: !media.tablet, label: claimLabel, loading: isClaiming, onClick: onClaim }))));
};
